/* a11y-text.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./a11y-text.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
// Assistive text to describe visual elements. Hidden for sighted users.
var styles = null;
var A11yText = function A11yText(props) {
  return /*#__PURE__*/React.createElement("span", _extends({
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c", "-a11yText"])
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, props));
};
export default A11yText;